// extracted by mini-css-extract-plugin
export default {"tableContainer":"AdminTable_tableContainer__86Ib2","expandIcon":"AdminTable_expandIcon__-3tJJ"};